import * as React from 'react';
import { AlertMessage } from '../AlertMessage';

export interface AlertData {
  title: string;
  type: string;
  link: string;
  linkText : string;
}

export interface AlertProps {
  alerts: AlertData[];
}

export const Alert = (props: AlertProps) =>
  <React.Fragment>
    {props.alerts !== undefined ? props.alerts.map((alert , index) => (
      <div key={"alert" + index} className={"row " + (props.alerts.length - 1 == index ? "callout-last-child" : "")}>
        <div className="col-12">
          <AlertMessage title={alert.title} type={alert.type} link={alert.link} linkText={alert.linkText} ></AlertMessage>
        </div>
      </div>)) : null
      }
    </React.Fragment>;